// client/src/pages/sections/groups/MigrationPromptHost.js
// Hosts the "Bring others along?" follow-up (MigrateMembersModal) that SplitMemberButton opens after a
// client leaves a signer group. It cannot live inside SplitMemberButton: the move marks the client
// pending, which drops its member card — and the button with it — before the server answers, so a
// modal owned by the button was unmounted by the time the answer arrived and never appeared.
// Same shape as toast.js: a module-level bus, one <MigrationPromptHost/> mounted for the section.
//
//   promptMigration({ newSgAnchor, anchorEntityType, candidates, onResolved, testMode, testSessionId })

import { useEffect, useState } from 'react';
import MigrateMembersModal from './MigrateMembersModal';

let listener = null;

export function promptMigration(props) {
  if (listener) listener(props);
}

export default function MigrationPromptHost() {
  const [props, setProps] = useState(null);
  useEffect(() => {
    listener = setProps;
    return () => { if (listener === setProps) listener = null; };
  }, []);
  if (!props) return null;
  return <MigrateMembersModal {...props} onClose={() => setProps(null)} />;
}
